import { CLINIC, MAIL_API } from "../clinic";

export async function sendClinicMail(payload) {
  const response = await fetch(MAIL_API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...payload,
      from: CLINIC.fromEmail,
      source: CLINIC.fromEmail,
      replyTo: payload.email || CLINIC.email,
    }),
  });

  if (!response.ok) {
    throw new Error("Request failed");
  }

  return response;
}
